import React, {useEffect} from "react";
import {useAppSelector} from "@/lib/hooks";

export default function AnjImage() {
    const isAnjReady = useAppSelector((state) => state.ui.isAnjReady);
    useEffect(() => {
        //@ts-expect-error — global defined asynchronously by anj-seal.js; onReady can fire before it exists
        if (isAnjReady && typeof anj_a298fc83_6db0_45d8_af73_467936ab9c27 !== "undefined") {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-expect-error
            anj_a298fc83_6db0_45d8_af73_467936ab9c27.init()
        }
    }, [isAnjReady])
    return (
        <div className={'w-[40px] h-[40px]'} id="anj-a298fc83-6db0-45d8-af73-467936ab9c27"
             data-anj-seal-id="a298fc83-6db0-45d8-af73-467936ab9c27" data-anj-image-size="128"
             data-anj-image-type="basic-small"></div>
    )
}
